// Credenciais locais do painel SIPREMO (gate de interface).
// 'hash' e o SHA-256 (hex) da senha. Para trocar a senha, gere um novo hash:
//   python3 -c "import hashlib; print(hashlib.sha256('NOVA_SENHA'.encode()).hexdigest())"
// Overrides via ambiente (CRA): REACT_APP_LOGIN_USER / REACT_APP_LOGIN_PASSWORD
export const USUARIOS = [
  {
    usuario: 'sipremo',
    nome: 'SIPREMO Operations',
    hash: '3485a1e9eeea03c2751c77bab80290d5e54d48ffd2ed7ba14894008edc3f33fa',
  },
  {
    usuario: 'vinci.demo',
    nome: 'VINCI Demo',
    hash: 'ff34bd392e616b01e1658b60c7a4b303df1ee3752323112f4a9f341ae9030f42',
  },
];

// Sessao valida por 12 horas
export const SESSAO_DURACAO_MS = 12 * 60 * 60 * 1000;
